export const TEST_ID = 'userDetailsPage';

export const CARD_HEADER_DETAIL_TYPE = 'user';

export const DETAIL_TYPE_EMAIL = 'email';

export const DETAIL_TYPE_PHONE = 'phone';

export const DETAIL_TYPE_ROLE = 'role';
